import { FormControl } from '@mui/material';
import styled from '@emotion/styled';
import color from 'src/theme/color';

export const PriorityContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const PriorityLabel = styled.span`
    color: ${color.white30};
    font-size: 14px;
    min-width: 60px;
    flex-shrink: 0;
`;

export const StyledFormControl = styled(FormControl)`
    width: 100px;
`;

export const MenuItemContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

export const selectStyles = {
    height: '32px',
    backgroundColor: color.blackRock,
    color: color.white90,
    fontSize: '12px',
    '& .MuiOutlinedInput-notchedOutline': {
        border: 'none'
    },
    '& .MuiSelect-icon': {
        color: `${color.white30} !important`
    },
    '&.Mui-focused .MuiSelect-icon': {
        color: `${color.lightningYellow} !important`
    },
    '&[aria-expanded="true"]': {
        backgroundColor: color.darkBlue
    },
    '&[aria-expanded="false"]': {
        backgroundColor: color.blackRock
    },
    '&.Mui-disabled': {
        backgroundColor: color.blackRock,
        opacity: 1,
        '& .MuiSelect-select': {
            color: `${color.white} !important`,
            '-webkit-text-fill-color': color.white
        }
    }
};

export const menuProps = {
    PaperProps: {
        sx: {
            backgroundColor: color.blackRock,
            '& .MuiMenuItem-root': {
                color: color.white90,
                padding: '8px 16px'
            },
            '& .MuiMenuItem-root.Mui-selected': {
                color: color.white,
                backgroundColor: 'transparent'
            },
            '& .MuiMenuItem-root:hover': {
                backgroundColor: color.darkBlue
            }
        }
    },
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
    }
} as const;
